import { useContext } from 'react'

import { EntryKeyContext } from '../../context/EntryKeyContext'
import { Description } from '../Description'
import * as S from './styled'

const BottomContent = () => {
  const { pageInfo: { descriptiveText } } = useContext(EntryKeyContext)

  return (
    <S.Wrapper>
      <Description description={descriptiveText} type="small" />
    </S.Wrapper>
  )
}

export default BottomContent
